import { action, observable } from 'mobx';
import queryString from 'query-string';
import history from '../History';
import i18n from '../i18n/i18n';

class CommonStore {
  constructor(root) {
    this.root = root;
  }

  @observable companyId = ''; // 회사 아이디
  @observable storeCode = ''; // 매장 코드
  @observable theme = '0'; // 테마
  @observable isOpenSnackbar = false; // 스낵바 오픈 여부
  @observable snackbarText = ''; // 스낵바 내용
  @observable error = null; // 에러
  @observable menuAnchorEl = null; // 메뉴 팝오버 오픈 여부
  @observable isMapOpen = false; // 지도 오픈 여부
  @observable map = {}; // 선택한 매장 데이터
  @observable isLanguageDialogOpen = false; // 언어선택 다이얼로그 오픈 여부
  @observable confirmDialog = {
    isOpen: false,
    description: '',
    onConfirm: () => {},
  };

  // 매장 세팅
  @action
  async setData(companyId, storeCode) {
    this.companyId = companyId;
    this.storeCode = storeCode;

    // 매장 데이터 조회
    await this.root.menuStore.setStoreData();

    // Up스마트오더 서비스 이용 가능 여부 조회
    if (!this.root.menuStore.storeData.useable) {
      history.replace('/service-unavailable');
    }

    // 매장 오픈 여부 체크
    if (!this.root.menuStore.isOpenStore) {
      history.replace(`/${this.companyId}/${this.storeCode}/errors/preparing${window.location.search}`);
    }

    // (일본) 배달 업체 구분 코드 검사
    if (this.root.menuStore.storeData.culture === 'ja-JP' && this.root.menuStore.storeData.isDeliveryCodeChecked) {
      const params = queryString.parse(window.location.search);
      if (!params.code) this.setError(i18n.t('shop.error.rescanQR'));
    }

    // 장바구니 데이터 조회
    this.root.cartStore.setCartDataFromSessionStorage();
  }

  @action
  setTheme(theme) {
    this.theme = theme;
  }

  // 스낵바 세팅
  @action
  setSnackbar(isOpen, text = '') {
    this.isOpenSnackbar = isOpen;
    this.snackbarText = text;
  }

  // 에러 세팅
  @action
  setError(error) {
    this.error = error;
  }

  // 지도 오픈 여부 설정
  @action
  setMapOpen(isOpen) {
    this.isMapOpen = isOpen;
  }

  // 매장 선택
  @action
  setMap(storeName, storeAddress1, storeAddress2, storePhone) {
    this.map = {
      storeName: storeName,
      storeAddress1: storeAddress1,
      storeAddress2: storeAddress2,
      storePhone: storePhone,
    };
  }

  @action
  setLanguageDialogOpen(value) {
    this.isLanguageDialogOpen = value;
  }

  @action
  openConfirmDialog(description, callback) {
    this.confirmDialog.isOpen = true;
    this.confirmDialog.description = description;
    this.confirmDialog.onConfirm = callback;
  }
}

export default CommonStore;
